<template>
	<div>
		<div class="page-content-box">
			<div class="page-filter-box">
				<el-row :gutter="16">
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-input v-model="params.searchValue" class="input-with-select" size="small">
							<el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
								<el-option label="演出ID" :value="1"></el-option>
								<el-option label="演出名称" :value="2"></el-option>
								<el-option label="场次ID" :value="3"></el-option>
								<el-option label="订单编号" :value="4"></el-option>
							</el-select>
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-input v-model="params.searchUserValue" class="input-with-select" size="small">
							<el-select v-model="params.searchUserType" slot="prepend" placeholder="请选择">
								<el-option label="B 类客户名称" :value="1"></el-option>
								<el-option label="B 类客户ID" :value="2"></el-option>
							</el-select>
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.status" placeholder="不限制开票状态" size="small">
							<el-option :value="-1" label="不限制开票状态"></el-option>
							<el-option :value="2" label="仅看已开票的"></el-option>
							<el-option :value="1" label="仅看待开票的"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.type" placeholder="不限制发票类型" size="small">
							<el-option :value="-1" label="不限制发票类型"></el-option>
							<el-option :value="2" label="仅看服务费的"></el-option>
							<el-option :value="1" label="仅看票款的"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.urgeStatus" placeholder="不限制催开票" size="small">
							<el-option :value="-1" label="不限制催开票"></el-option>
							<el-option :value="1" label="仅看催开票的"></el-option>
							<el-option :value="2" label="仅看未被催开票"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.invoiceTitleType" placeholder="不限制抬头类型" size="small">
							<el-option :value="-1" label="不限制抬头类型"></el-option>
							<el-option :value="2" label="仅看企业的"></el-option>
							<el-option :value="1" label="仅看个人的"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
						<div class="clearfix timeType">
							<el-input class="input-with-select fl" size="small">
								<el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
									<el-option label="申请时间" :value="1"></el-option>
									<el-option label="开票时间" :value="2"></el-option>
									<el-option label="场次时间" :value="3"></el-option>
								</el-select>
							</el-input>
							<el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
								end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
								:default-time="['00:00:00', '23:59:59']" unlink-panels>
							</el-date-picker>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
						<el-button type="primary" @click="search" size="small">搜索</el-button>
						<el-button @click="reset" size="small">重置</el-button>
					</el-col>
				</el-row>
			</div>
			<div class="page-btns-box">
				<el-button type="primary" :loading="downLoading" size="small" icon="el-icon-download"
					@click="download">下载发票信息</el-button>
				<el-button type="primary" size="small" icon="el-icon-upload2"
					@click="batchupload(1)">批量上传票款发票</el-button>
				<el-button type="success" size="small" icon="el-icon-upload2"
					@click="batchupload(2)">批量上传服务费发票</el-button>
			</div>
			<div class="page-list-box">
				<el-table :data="dataList" style="width: 100%" border v-loading="listLoading" size="small"
					header-row-class-name="page-list-table">
					<el-table-column prop="orderSn" label="订单编号" min-width="166"></el-table-column>
					<el-table-column prop="statusView" label="开票状态"></el-table-column>
					<el-table-column prop="typeView" label="发票类型"></el-table-column>
					<el-table-column prop="goodsId" label="演出ID"></el-table-column>
					<el-table-column prop="goodsName" label="演出名称" min-width="200"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="sessionName" label="场次名称" min-width="200"></el-table-column>
					<el-table-column prop="userName" label="B 类客户" min-width="200"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="amount" label="开票金额" min-width="100"></el-table-column>
					<el-table-column prop="titleType" label="发票抬头类型" min-width="146"></el-table-column>
					<el-table-column prop="title" label="发票抬头" min-width="146" show-overflow-tooltip></el-table-column>
					<el-table-column prop="taxNumber" label="税号" min-width="146"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="documentNumber" label="身份证号" min-width="146"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="email" label="邮箱" min-width="146"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="applyTime" label="申请时间" min-width="146"></el-table-column>
					<el-table-column prop="invoiceTime" label="开票时间" min-width="146"></el-table-column>
					<el-table-column prop="urgeNum" label="催开票" min-width="146"></el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<el-button type="text" size="small" v-if="scope.row.status === 1" @click="upload(scope.row)"
								icon="el-icon-upload2">上传</el-button>
							<el-button type="text" size="small" v-if="scope.row.status === 2" icon="el-icon-view"
								@click="upload(scope.row)">查看/重传</el-button>
							<el-button type="text" size="small" @click="edit(scope.row)"
								icon="el-icon-edit-outline">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="data" class="page-pagination-box">
				<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
				</el-pagination>
			</div>
		</div>
		<upload-invoice ref="UploadInvoice" @onUpdate="getDataList"></upload-invoice>
		<edit-invoice ref="EditInvoice" @onUpdate="getDataList"></edit-invoice>
		<batch-upload-invoice ref="BatchUploadInvoice" @onUpdate="getDataList"></batch-upload-invoice>
	</div>
</template>

<script>
	import UploadInvoice from "./components/upload-invoice";
	import EditInvoice from "./components/edit-invoice";
	import BatchUploadInvoice from "./components/batch-upload-invoice";
	import {
		downloadFileTmp
	} from '@/assets/js/commonApi.js';
	const defaultParams = {
		pageNo: 1,
		pageSize: 10,
		searchType: 1,
		searchValue: '',
		searchUserValue: '',
		searchUserType: 1,
		status: 1,
		type: 2,
		urgeStatus: -1,
		invoiceTitleType: -1,
		timeType: 1,
		beginTime: "",
		endTime: "",
	}
	export default {
		components: {
			UploadInvoice,
			BatchUploadInvoice,
			EditInvoice
		},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo:parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || "",
					searchUserType: parseInt(this.$route.query.searchUserType || 1),
					searchUserValue: this.$route.query.searchUserValue || "",
					status:parseInt(this.$route.query.status || 1),
					type:parseInt(this.$route.query.type || 2),
					urgeStatus:parseInt(this.$route.query.urgeStatus || -1),
					invoiceTitleType:parseInt(this.$route.query.invoiceTitleType || -1),
					timeType: parseInt(this.$route.query.timeType || 1),
					beginTime: this.$route.query.beginTime || '',
					endTime: this.$route.query.endTime || ''					
				},
				listLoading: true,
				datetimerange: [],
				downLoading: false,
				upLoading: false,
				UrgeNum: ''
			}
		},

		mounted() {
			this.getDataList();
		},
		methods: {

			//获取列表
			getDataList() {
				this.listLoading = true;
				this.$request({
						url: "/invoice/record/list",
						method: "POST",
						data: {
							...this.params,
							beginTime: this.datetimerange && this.datetimerange[0] || '',
							endTime: this.datetimerange && this.datetimerange[1] || ''
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result;
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.datetimerange = []
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			//上传
			upload(obj) {
				this.$refs.UploadInvoice.show(obj);
			},
			//编辑
			edit(obj) {
				this.$refs.EditInvoice.show(obj);
			},
			batchupload(type) {
				this.$refs.BatchUploadInvoice.show(type);
			},
			//下载
			async download() {
				this.downLoading = true;
				this.$request({
						url: '/invoice/record/export',
						method: "POST",
						data: {
							...this.params,
							beginTime: this.datetimerange && this.datetimerange[0] || '',
							endTime: this.datetimerange && this.datetimerange[1] || ''
						},
					})
					.then((res) => {
						const {
							state,
							msg
						} = res.data;
						if (state == 1) {
							this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
								confirmButtonText: '立即查看',
								cancelButtonText: '稍后再看',
								type: 'success',
								center: true,
								closeOnClickModal: false
							}).then(() => {
								this.$router.push({
									path: '/workbench/downloadList'
								})
							}).catch(() => {})
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.downLoading = false;
					});
			}
		}
	}
</script>